import { render, staticRenderFns } from "./PageHome.vue?vue&type=template&id=54a42aa0&"
import script from "./PageHome.vue?vue&type=script&lang=js&"
export * from "./PageHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports